import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Card, CardMedia, Typography } from '@one-thd/sui-atomic-components';
import SingleProductOverview from './SingleProductOverview'; // FAILS
import { getDdo, getProductImage, triggerAnalyticsCustomEvent } from '../helpers';
import { dataModel } from '../dataModel';

export const MultiProductOverviewsComponent = ({ itemIds }) => {
  const [selectedItemId, setSelectedItemId] = useState(itemIds[0]);
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  useEffect(() => {
    setSelectedItemId(itemIds[0]);
  }, [itemIds]);

  const handleItemClick = (product) => {
    setSelectedItemId(product?.itemId);
    triggerAnalyticsCustomEvent('zone-b.click', getDdo(product, 'product-details-pipfigurator'));
  };

  const { data, loading } = useDataModel('products', { variables: { itemIds } });
  if (loading) return null;

  if (!data?.products || data?.products.length === 0) {
    return null;
  }

  const products = data.products;
  const selectedProduct = products.find((item) => item.itemId === selectedItemId);

  return (
    <div className="sui-max-w-full" data-component="ConfigProductDetails" data-testid="Config-product-details">
      <div className={`${isMobile ? 'sui-grid-flow-col' : 'sui-grid-cols-5'} sui-grid sui-grid-rows-1 sui-gap-4`}>
        {data?.products?.map((product, index) => (
          <Card
            key={product.itemId}
            className={`${selectedItemId === product.itemId ? 'sui-border-2 sui-border-strongest' : 'sui-border-1'
              } sui-max-w-xs`}
            onClick={() => handleItemClick(product)}
          >
            <CardMedia
              data-testid={`Config-product-detail-button-${index}`}
              component="img"
              height={{ sm: '40px', md: '116px', lg: '253px' }}
              width={{ sm: '40px', md: '116px', lg: '253px' }}
              src={getProductImage(product?.media?.images)}
              alt={product?.title}
            />
          </Card>
        ))}
      </div>
      {selectedItemId ? (
        <div data-component="BodyConfigProductDetails">
          {selectedProduct && selectedProduct !== null ? (
            <div className="sui-grid sui-mt-4">
              <Typography variant="body-lg" weight="bold" data-testid="tile-product-title">
                {selectedProduct?.identifiers?.productLabel}
              </Typography>
            </div>
          ) : null}
          <div className="sui-mt-4" data-testid="product-detail-accordion-body">
            <SingleProductOverview itemId={selectedItemId} />
          </div>
        </div>
      ) : null}
    </div>
  );
};

MultiProductOverviewsComponent.displayName = 'MultiProductOverviews';
const propTypes = {
  itemIds: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  itemIds: [],
};

MultiProductOverviewsComponent.propTypes = propTypes;
MultiProductOverviewsComponent.defaultProps = defaultProps;

export const MultiProductOverviews = withErrorBoundary(MultiProductOverviewsComponent);

MultiProductOverviews.dataModel = dataModel;
MultiProductOverviews.propTypes = propTypes;
MultiProductOverviews.defaultProps = defaultProps;
